export { default } from './CostGuidePage';
export { getServerSideProps } from './costGuidePageProps';
